import { useQuery } from "@tanstack/react-query"
import { useParams } from "react-router-dom"
import { getSession } from "@/api/api"
import { ExpiredTokenError } from "@/api/errors"
import { getCachedInvitationId } from "./invitation-cache"

const useCurrentToken = () => {
  const params = useParams<{ token_id: string }>()
  const token_id = params.token_id as string

  const query = useQuery({
    queryKey: ["session", token_id],
    queryFn: () => getSession(),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
  })

  const session = query.data

  if (!session) {
    return {
      token_id,
      document_id: null,
      invitation_id: null,
      signee_id: null,
      isReady: false,
    }
  }

  // Multi-invitation guard: a stale shared cookie can resolve to a different
  // invitation than the URL implies. If we previously cached the mapping for
  // this URL token_id, treat a divergent invitation_id as expired.
  const cached = getCachedInvitationId(token_id)
  if (cached !== undefined && cached !== session.invitation_id) {
    throw new ExpiredTokenError()
  }

  return {
    token_id,
    document_id: session.document_id,
    invitation_id: session.invitation_id,
    signee_id: session.signee_id,
    isReady: true,
  }
}

export { useCurrentToken }
